"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * MyBuy Backend API
 * ## Release Notes  ### v0.0.1  Work in progress
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.AddressWriteableAllOfToJSON = exports.AddressWriteableAllOfFromJSONTyped = exports.AddressWriteableAllOfFromJSON = void 0;
function AddressWriteableAllOfFromJSON(json) {
    return AddressWriteableAllOfFromJSONTyped(json, false);
}
exports.AddressWriteableAllOfFromJSON = AddressWriteableAllOfFromJSON;
function AddressWriteableAllOfFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'firstName': json['firstName'],
        'lastName': json['lastName'],
    };
}
exports.AddressWriteableAllOfFromJSONTyped = AddressWriteableAllOfFromJSONTyped;
function AddressWriteableAllOfToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'firstName': value.firstName,
        'lastName': value.lastName,
    };
}
exports.AddressWriteableAllOfToJSON = AddressWriteableAllOfToJSON;
//# sourceMappingURL=AddressWriteableAllOf.js.map